<template>
  <i :class="groups[group].icon"></i>
</template>

<script>

  import UserService from "@/services/user-service"

  export default {

    data() {
      return {
        groups: UserService.GROUPS,
      }
    },

    props: ["group"], 

  }
</script>